/**
 * @description 微信设置分享参数
 * @author librajt , duanjun
 */
import { IShareConfig } from '@umu/umu-types';
import { BaseShare } from './baseShare';
import { getWxJsConfig } from '../../hooks/useGetWxJsConfig';

// 微信分享参数
export interface IWeixinShareConfig extends IShareConfig {
    // 微信
    title: string;
    desc: string;
    link: string;
    imgUrl: string;
    shareUrl: string;
}

export class WxShare extends BaseShare {
    public constructor() {
        super();
        if (typeof wx !== 'undefined' && wx.ready) {
            getWxJsConfig().then((_res) => {
                wx.ready(() => {
                    wx.onMenuShareAppMessage(this.shareConfig);
                    wx.onMenuShareTimeline(this.shareConfig);
                });
            }, (_res) => {
                console.warn('wx config fail');
            });
        }
    }

    /**
     * @desc 更新微信与app参数
     * @param wxConfig 微信参数
     */
    public setup(wxConfig?: IShareConfig) {
        // const defaultIcon = this.appendHost(require('./images/shareLogo.png'));
        // wxConfig.imgUrl = wxConfig.imgUrl || defaultIcon;
        // Object.assign(this.shareConfig, wxConfig); // 这种方式下，默认值会被传入的空值覆盖掉
        /* const config = wxConfig || {} as IShareConfig;
        for (const key in this.shareConfig) {
            if (this.shareConfig.hasOwnProperty(key)) {
                const prop = key as keyof IWeixinShareConfig;
                this.shareConfig[prop] = config[prop] || this.shareConfig[prop];
            }
        } */
        // this.shareConfig.link = this.filter(this.shareConfig.link);
        this.mergeSetup(wxConfig);
    }

    // public getIcon(type: number) {
    //     let imgUrl = IconMap[type];
    //     imgUrl = this.appendHost(imgUrl);
    //     return imgUrl;
    // }

    // public appendHost(imgPath: string) {
    //     if (imgPath && !/^http/i.test(imgPath)) {
    //         imgPath = $location.protocol + '//' + $location.hostname + imgPath;
    //     }
    //     return imgPath;
    // }
}
